import { defineComponent as _defineComponent } from 'vue'
import Chart from '@/components/Charts/Chart.vue';
import { useI18n } from '@/composables/i18n';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import { isNil } from '@/utils/misc';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryComparisonKpiWidget',
  props: {
    data: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: T | null;
  generator: ChartGenerator<T>;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const { t } = useI18n();

const hasData = computed<boolean>(() => !isNil(props.data));

return { __sfc: true,props, t, hasData, Chart }
}

})